const state = {
  donationWidget: {
    // campaignId: '1',
    campaign: {},
    campaignId: '',
    pledgeId: '',
    amount: '7500', // in pennies
    otherAmountInView: false,
    enteredOtherAmount: '',
    occurrence: 'once', // or 'monthly'
    isAnonymous: false,
    hasDedication: false,
    inHonorOfSelection: 'honor', // or memory
    honoreeName: '',
    honoreeEmail: '',
    honoreeMessage: '',
    doubleTheDonation: {},
    paymentToken: '',
    paymentIdentifier: '',

    firstName: '',
    lastName: '',
    businessName: '',
    email: '',
    city: '',
    state: '',
    zip: '',
    ccNumber: '',
    cvv: '',
    ccLast4: '',
    expMonth: '',
    expYear: '',

    // test

    // firstName: 'myFirstName',
    // lastName: 'lastName',
    // email: 'a@a.com',
    // city: 'den',
    // state: 'co',
    // zip: '12345',
    // ccNumber: '4000000000000127',
    // // ccNumber: '4242424242424242',
    // cvv: '123',
    // ccLast4: '',
    // expMonth: '12',
    // expYear: '2019',

    // end test

    isProcessing: false,
    paidForTransactionFee: false,
    calculatedTransactionFee: 0,
    donationId: '',
    steps: {
      donation: {
        isInView: true,
        isValid: false,
      },
      contact: {
        isInView: false,
        isValid: false,
      },
      payment: {
        isInView: false,
        isValid: false,
      },
      thankYou: {
        isInView: false,
        isValid: false,
      },
    },

    successfulTransactionData: {},
    pledge: null,
  },
}

const getters = {
  donationWidget: state => {
    return state.donationWidget
  },
}

const mutations = {
  addCampaignId: (state, campaignId) => {
    state.donationWidget.campaignId = campaignId
  },
  addPledgeId: (state, pledgeId) => {
    state.donationWidget.pledgeId = pledgeId
  },
  updateAmount: (state, amount) => {
    state.donationWidget.amount = amount
  },
  updateEnteredOtherAmount: (state, amount) => {
    state.donationWidget.enteredOtherAmount = amount
  },
  updateOtherAmountInView: (state, flag) => {
    state.donationWidget.otherAmountInView = flag
  },
  updateCampaign: (state, campaign) => {
    state.donationWidget.campaign = campaign
  },
  updatePledge: (state, pledge) => {
    state.donationWidget.pledge = pledge
    state.donationWidget.amount = pledge.amountDue
    state.donationWidget.enteredOtherAmount = pledge.amountDue
    state.donationWidget.firstName = pledge.first_name
    state.donationWidget.lastName = pledge.last_name
    state.donationWidget.email = pledge.email
    state.donationWidget.otherAmountInView = 'other'
  },
  updateDonationData: (state, data) => {
    state.donationWidget.hasDedication = data.hasDedication
    state.donationWidget.occurrence = data.occurrence
    state.donationWidget.otherAmountInView = data.otherAmountInView
    state.donationWidget.isAnonymous = data.isAnonymous
    state.donationWidget.inHonorOfSelection = data.inHonorOfSelection
    state.donationWidget.honoreeName = data.honoreeName
    state.donationWidget.honoreeEmail = data.honoreeEmail
    state.donationWidget.honoreeMessage = data.honoreeMessage
  },
}

const actions = {
  addCampaignId: ({commit}, payload) => {
    commit('addCampaignId', payload)
  },
    addPledgeId: ({commit}, payload) => {
      commit('addPledgeId', payload)
  },
  updateAmount: ({commit}, payload) => {
    commit('updateAmount', payload)
  },
  updateEnteredOtherAmount: ({commit}, payload) => {
    commit('updateEnteredOtherAmount', payload)
  },
  updateOtherAmountInView: ({commit}, payload) => {
    commit('updateOtherAmountInView', payload)
  },
  updateCampaign: ({commit}, payload) => {
    commit('updateCampaign', payload)
  },
  updatePledge: ({commit}, payload) => {
    commit('updatePledge', payload)
  },
  updateDonationData: ({commit}, payload) => {
    commit('updateDonationData', payload)
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
